<script>
    

  
import CardsInscricao from '../../componentes_basicos/CardsInscricao.svelte';
import CardsGrid from '../../componentes_basicos/CardGrid.svelte';
    import Conexoes from '../../Classes/Conexoes';
    import Constantes from '../../Classes/Constantes';
    import LoadingTela from '../../componentes_basicos/LoadingTela.svelte';
    import { onMount } from 'svelte';
    import ArmazenaVariaveisInscricao from '../../Classes/ArmazenaVariaveisInscricao';


  let cards=[];
  let carregando=false;
  let retorno=[];
  let api = Constantes.api_consultar_padrao;
  let texto_botao="Entrar em contato"
  


  const params = {

    query_code:"consultar_assessorias",


  }
 
 async function PegarDados(){
 carregando=true;
 cards=[];
  let conexoes = new Conexoes();
  retorno  = await conexoes.conecta(api, params);
  carregando=false;
   let c ={};
   //console.log(retorno);  
   retorno.forEach(element => {
    c ={};
    c['textinho'] = element.textinho_destaque;
    c['titulo'] = element.nome_assessoria;
    c['imageUrl'] = element.imageUrl; 
    c['descricao'] = element.descricao;
    c['publicar'] = element.publicar;
    c['texto_botao'] = element.texto_botao;
    c['botao_habilitado'] = element.botao_habilitado;
    c['navegarPara'] =element.navegar_para;
    c['id'] =element.id;
    c['body'] = element;
    
    cards=[...cards, c];
    //console.log('cards' , cards)
   });
 }
 

onMount(()=>PegarDados());




</script>

<style>
  .container {
    max-width: 80%;
     align-content: center;
    margin-bottom:4em;
    margin-top:3em;
  } 
</style>

<LoadingTela isLoading={carregando} />
<div class="container">
{#if cards && cards.length>0}
<CardsGrid {cards} {texto_botao} />
{/if}
</div>



 

